// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.search-row {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px; /* spazio tra campo e bottone */
}

.search-field {
  padding: 0;
  flex: 1; /* l'input occupa tutto lo spazio disponibile */
}
.search-field ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

.search-button {
  white-space: nowrap; /* evita che il testo vada a capo */
  height: 56px; /* allinea con l’altezza del mat-form-field */
}

table {
  width: 100%;
  border-collapse: collapse;
}

th.mat-header-cell, td.mat-cell {
  padding: 8px 12px;
}

tr.selected {
  background-color: #e3f2fd;
}

tr:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  gap: 10px;
}

mat-paginator {
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/registry/customers/enterprises-search/enterprises-search.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA,EAAA,+BAAA;AAEF;;AACA;EACE,UAAA;EACA,OAAA,EAAA,+CAAA;AAEF;AAAE;EACE,4BAAA;AAEJ;;AAEA;EACE,mBAAA,EAAA,mCAAA;EACA,YAAA,EAAA,6CAAA;AACF;;AAKA;EACE,WAAA;EACA,yBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AAFF;;AAMA;EACE,gBAAA;AAHF","sourcesContent":[".search-row {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  gap: 10px; /* spazio tra campo e bottone */\r\n}\r\n\r\n.search-field {\r\n  padding: 0;\r\n  flex: 1; /* l'input occupa tutto lo spazio disponibile */\r\n  \r\n  ::ng-deep .mat-form-field-wrapper {\r\n    padding-bottom: 0 !important;\r\n  }\r\n}\r\n\r\n.search-button {\r\n  white-space: nowrap; /* evita che il testo vada a capo */\r\n  height: 56px; /* allinea con l’altezza del mat-form-field */\r\n}\r\n\r\n\r\n\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\nth.mat-header-cell, td.mat-cell {\r\n  padding: 8px 12px;\r\n}\r\n\r\ntr.selected {\r\n  background-color: #e3f2fd;\r\n}\r\n\r\ntr:hover {\r\n  background-color: #f5f5f5;\r\n  cursor: pointer;\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 1rem;\r\n  gap: 10px;\r\n}\r\n\r\n// Stili per il paginatore\r\nmat-paginator {\r\n  margin-top: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
